import React, { useState, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  makeStyles,
  Avatar,
  withStyles
} from "@material-ui/core";
import PropTypes from "prop-types";
import E_Card_Content from "./_card_content";
import E_PaginatationComponent from "./e_alerts_notification_pagination";
import {useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
const useStyle = makeStyles((theme) => ({
  boxPadding: {
    padding: "1% 0%",
  },
  divPadding: {
    padding: "0% 2%",
  },
  avatarStyle: {
    width: "25px",
    height: "25px",
    fontSize: "inherit",
    background: theme.palette.eTertiary?.base,
    marginLeft: "0.3rem !important"
  },
  iconLabelWrapper2: {
    flexDirection: "row-reverse",
  },
  labelContainer: {
    width: "auto",
    padding: 0,
  },
  tabPadding: {
    '& .MuiTab-root': {
      padding: 0,
      minWidth: 'unset'
    },
    '& .MuiTab-wrapper': {
      width: 'unset !important',
      padding: '0.5rem',
      textTransform:"none !important",
    }
  }
}));

const AntTabs = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid " + theme.palette.eSecondary?.base,
    minHeight: "0px",
    "& button": {
      minHeight: "35px",
    },
  },
  indicator: {
    backgroundColor: theme.palette.eSecondary?.base,
  },
}))(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    fontSize: "11px !important",
    minWidth: "32%",
    "& .MuiAvatar-circle": {
      backgroundColor: theme.palette.eDanger?.dark
   }
  },
  selected: {
    background: theme.palette.eSecondary?.selected + " !important",
    color: theme.palette.eWhite?.base + " !important",
    borderRadius: "10px 10px 0px 0px",
  },
}))(Tab);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  let classes = useStyle();
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} className={classes.boxPadding}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

  export default function E_Prepaid_Alerts({ item, noContent, noContentContentReady, value, setValue, origin, autoOpenData, setAutoOpenData}) {
  let count = useSelector((state) => state?.e_meterAlertsDataCount?.data);
  let [originCount, setCount] = useState(0);
  let classes = useStyle();
  let [sortedItem,setSort]=useState();
  let prepaidRowCount = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.E_ALERTS_NOTIFICATION_PREPAID_PAGINATION
    );
  const [rowsPerPage, setRowsPerPage] = useState(prepaidRowCount);
  const [page, setPage] = useState(1);
  let totalPagesCount = [];
  let paginationData = [];
  const isDesktop = useMediaQuery({ minWidth: 1280 });
  const handleChange = (e, newValue) => {
    setPage(1)
    setValue(newValue);
  };

  useEffect(() => {
    if(autoOpenData?.Origin === "PrepaidLowBalance") {
      setValue(0);
    } else if(autoOpenData?.Origin === "PrepaidAccountCharge") {
      setValue(1);
    } else if(autoOpenData?.Origin === "PrepaidMinimumBalance") {
      setValue(2)
    }
  }, [autoOpenData, item])

  const updateRowData = (index) => {
    return item[index]?.alertsData?.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );
  };

  item &&
    item.map((eachItem, index) => {
      totalPagesCount.push({
        [index]: Math.ceil(eachItem?.alertsData?.length / rowsPerPage),
      });
      if (
        Math.ceil(eachItem?.alertsData?.length / rowsPerPage) !==
        totalPagesCount[index][index]
      ) {
        totalPagesCount.push({
          [index]: Math.ceil(eachItem?.alertsData?.length / rowsPerPage),
        });
      }
      paginationData = updateRowData(index);
    });
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  useEffect(() => {
    if (item.length) {
      setSort(item.sort((a, b) => a.insideWidgetRank - b.insideWidgetRank));
      item &&
        item.map((eachItem) => {
          if (eachItem?.alertsData?.length) {
            eachItem.alertsData.sort(
              (a, b) =>
                new Date(b.StartDate ? b.StartDate : b.InsertedDateTime) -
                new Date(a.StartDate ? a.StartDate : a.InsertedDateTime)
            );
          }
        });
    }
  }, [item]);

  useEffect(() => {
    if (count && origin) {
     setCount(count);
    }
  }, [count, origin, count?.[origin]?.length]);
  return (
    <div className={classes.divPadding}>
      <AntTabs value={value} onChange={handleChange}
      variant={!isDesktop ? "scrollable" : ""}
      scrollButtons={!isDesktop ? "on" : ""}
      className={classes.tabPadding}
      >
        {sortedItem && sortedItem.map((content, k) => (
          <AntTab
            label={content.title}
            {...a11yProps(k)}
            icon={
              originCount?.[content.origin]?.length > 0 && (
                <Avatar className={classes.avatarStyle}>{originCount?.[content.origin]?.length}</Avatar>
              )
            }
            classes={{
              wrapper: classes.iconLabelWrapper2,
              labelContainer: classes.labelContainer,
            }}            
          />
        ))}
      </AntTabs>
      {item.map((content, k) => (
        <TabPanel value={value} index={k}>
          <E_Card_Content
            data={content?.alertsData?.slice(
              (page - 1) * rowsPerPage,
              page * rowsPerPage
            )}
            origin={content.origin}
            displayPadding={false}
            noContent={noContent}
            noContentContentReady={noContentContentReady}
            totalPages={totalPagesCount[k]?.[k]}
            handlePageChange={handlePageChange}
            page={page}
            autoOpenData={autoOpenData}
            setAutoOpenData={setAutoOpenData}
          />
        </TabPanel>
      ))}
    </div>
  );
}
